<template>
  <NotificationTypeWrapper
    ref="wrapper"
    :notification="notification"
  >
    <p class="my-0">
      <strong v-text="creatorName" /> has created a new
      <a
        :href="notification.attributes.data.post.link"
        :title="notification.attributes.data.post.title"
        v-text="'discussion post'"
      />
      which requires approval.
    </p>
    <div v-if="!notification.attributes.action_taken">
      <blockquote
        class="border-l-4 pl-4 border-grey"
        :cite="notification.attributes.data.post.link"
      >
        <h4
          class="italic font-bold"
          v-text="notification.attributes.data.post.title"
        />
        <p
          class="italic mt-0 pt-0"
          v-text="notification.attributes.data.post.body"
        />
      </blockquote>
      <div class="mt-4 flex justify-center">
        <button
          type="button"
          class="btn btn--sm mr-2"
          @click.prevent="approve"
          v-text="'Approve'"
        />
        <button
          type="button"
          class="btn btn--sm btn--danger ml-2"
          @click="reject"
          v-text="'Reject'"
        />
      </div>
    </div>
    <div
      v-if="notification.attributes.action_taken"
      slot="actionMessage"
      class="flash mt-4 -mx-3 -mb-3 rounded-b"
      role="alert"
      :class="notificationApprovalClass"
    >
      {{ notification.actionBy.attributes.full_name }}
      <b v-text="notification.attributes.action_taken.toLowerCase()" />
      this discussion.
      <br>
      <small
        class="text-xs text-grey-light"
        v-text="dateActioned"
      />
    </div>
  </NotificationTypeWrapper>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import NotificationTypeMixin from './NotificationTypeMixin'

export default {
  name: 'DiscussionPostRequiresApprovalNotification',
  mixins: [NotificationTypeMixin],
  computed: {
    notificationApprovalClass() {
      return {
        'flash--success': this.notification.attributes.action_taken === 'Approved',
        'flash--danger': this.notification.attributes.action_taken === 'Declined',
      }
    },
    dateActioned() {
      return this.moment(this.notification.attributes.updated_at).fromNow()
    },
    creatorName() {
      return this.notification.attributes.data.post.creator
    },
    actionLink() {
      return this.$urlGenerator.active() + 'documents/shares'
    },
  },
  methods: {
    ...mapActions([
      'discussionApprovePost',
      'discussionRejectPost',
      'notificationSetNotification',
    ]),
    approve() {
      this.discussionApprovePost(this.notification.context).then(this.refresh)
    },
    reject() {
      this.discussionRejectPost(this.notification.context).then(this.refresh)
    },
    refresh() {
      this.$refs['wrapper'].loading = true

      this.$api.active().get(`notifications/${this.notification.id}`).then((response) => {
        this.notificationSetNotification(response.data)

        this.$refs['wrapper'].markRead()
      })
    },
  },
}
</script>
